import React, { useState } from 'react';
import { User, Building2 } from 'lucide-react';
import { useFirestoreData } from '../../services/firestore';

export const RegistrationScreen = ({ user, onSubmit, onCancel }) => {
    const [name, setName] = useState(user.name || '');
    const [deptId, setDeptId] = useState('');
    
    // Usamos o hook para puxar os departamentos e exibir no select
    const { data: depts } = useFirestoreData('departments', true);

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-slate-950 text-white transition-colors duration-300">
            <div className="w-full max-w-md p-8 rounded-2xl shadow-2xl border border-slate-800 bg-slate-900 flex flex-col animate-fade-in">
                
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold mb-1">Gestão de Pessoas</h2>
                    <p className="text-slate-400 text-sm">Complete seu cadastro para acessar</p>
                </div>

                <div className="bg-slate-800 p-4 rounded-xl mb-6 flex items-center gap-4 border border-slate-700">
                    <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center font-bold text-lg">
                        {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <div className="text-left">
                        <p className="font-bold text-sm leading-tight">{user.name}</p>
                        <p className="text-xs text-slate-400">{user.email}</p>
                    </div>
                </div>

                <div className="space-y-4 mb-6">
                    <div>
                        <label className="block text-xs font-bold text-slate-400 mb-1">Como quer ser chamado? *</label>
                        <div className="relative">
                            <User className="absolute left-3 top-2.5 text-slate-500" size={16} />
                            <input
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                className="w-full bg-[#0B1120] border border-slate-700 rounded-lg py-2.5 pl-10 pr-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                                placeholder="Seu nome"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-slate-400 mb-1">Seu Departamento *</label>
                        <div className="relative">
                            <Building2 className="absolute left-3 top-2.5 text-slate-500" size={16} />
                            <select
                                value={deptId}
                                onChange={e => setDeptId(e.target.value)}
                                className="w-full bg-[#0B1120] border border-slate-700 rounded-lg py-2.5 pl-10 pr-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none appearance-none"
                            >
                                <option value="">Selecione...</option>
                                {depts.map(d => (
                                    <option key={d.id} value={d.id}>{d.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <button
                    onClick={() => {
                        if (!name || !deptId) return alert("Preencha todos os campos.");
                        onSubmit({ name, departmentId: deptId });
                    }}
                    className="w-full bg-[#2563EB] hover:bg-blue-600 text-white font-bold py-3 rounded-xl transition-colors mb-4"
                >
                    Concluir Solicitação
                </button>

                <button onClick={onCancel} className="w-full text-slate-400 hover:text-white text-sm font-bold py-2 transition-colors">
                    Cancelar e Voltar
                </button>
            </div>
        </div>
    );
};

export default RegistrationScreen;
